"use client";
import React, { Fragment, useState } from "react";

import { useNavigate } from "react-router-dom";

import logo_main from "../../assets/images/logo_main.png";
import { MenuMobile } from "../MenuMobile/MenuMobile";
import { SearchMenu } from "../SearchMenu/SearchMenu";

import {
  BurgerMobile,
  DropdownMenu,
  DropdownWrapper,
  HeaderButton,
  HeaderContainer,
  HeaderShell,
  HeaderLeft,
  HeaderMenuButton,
  HeaderRight,
  Icon,
  IconDot,
  Logo,
  MenuItem,
  MobileButton,
  SearchMobile,
  TGButton,
} from "./styles";

export const Header = () => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  const navigate = useNavigate();

  return (
    <Fragment>
      <HeaderShell>
        <HeaderContainer>
          <MobileButton onClick={() => setShowSearch(true)}>
            <SearchMobile />
          </MobileButton>
          <HeaderLeft>
            <DropdownWrapper>
              <HeaderMenuButton>
                  Консалтинг
                <Icon />
              </HeaderMenuButton>
              <DropdownMenu>
                <MenuItem to="/services/cv-ready">
                  Резюме под ключ <IconDot />
                </MenuItem>
                <MenuItem to="/services/talkitout">
                  Сессия «Выговориться» <IconDot />
                </MenuItem>
                <MenuItem to="/services/career-consult">
                    Карьерная консультация <IconDot />
                </MenuItem>
                <MenuItem to="/services/search-support">
                    Пакетное сопровождение «Хочу оффер» <IconDot />
                </MenuItem>
                <MenuItem to="/services/vacancies">
                  Подписка на поиск вакансий <IconDot />
                </MenuItem>
                <MenuItem to="/services/linkedin-boost">
                  Развитие Linkedin профиля <IconDot />
                </MenuItem>
                <MenuItem to="/services/probation-support">
                    Сопровождение испытательного срока <IconDot />
                </MenuItem>
              </DropdownMenu>
            </DropdownWrapper>
            <HeaderButton to="/services/it-hiring">ИТ подбор</HeaderButton>
            <HeaderButton to="/services/it-training">Обучение</HeaderButton>
          </HeaderLeft>
          <Logo src={logo_main} onClick={() => navigate("/")}/>
          <MobileButton onClick={() => setShowMenu(true)}>
            <BurgerMobile />
          </MobileButton>
          <HeaderRight>
            <DropdownWrapper>
              <HeaderMenuButton>О нас
                <Icon />
              </HeaderMenuButton>
              <DropdownMenu>
                <MenuItem to="/company">О компании
                  <IconDot />
                </MenuItem>
                <MenuItem to="/reviews">Отзывы
                  <IconDot />
                </MenuItem>
                <MenuItem to="/blog">Блог
                  <IconDot />
                </MenuItem>
              </DropdownMenu>
            </DropdownWrapper>
            <HeaderMenuButton onClick={() => setShowSearch(true)}>Поиск</HeaderMenuButton>
            <TGButton
              href="https://t.me/ProhorovaConsult"
              target="_blank"
              rel="noopener noreferrer"
            >Задать вопрос в ТГ
            </TGButton>
          </HeaderRight>
        </HeaderContainer>
      </HeaderShell>
      <SearchMenu
        searchQuery={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onClose={() => setShowSearch(false)}
        visible={showSearch}
      />
      <MenuMobile visible={showMenu} onClose={() => setShowMenu(false)} />
    </Fragment>
  );
};
